import { setStore, getStore, removeStore } from '@/util/store'

export default {
  methods: {
    /**
     * 前往页面
     */
    $go(path, query) {
      this.$router.push({ path, query })
    },
    /**
     * 前往页面
     */
    $go_blank(path, query) {
      // this.$router.push({ path, query })
      const fullUrl = this.$router.resolve({
        path,
        query,
      }).href;
      // Open the URL in a new tab
      window.open(fullUrl, '_blank');
    },
    /**
     * 返回页面
     */
    $back() {
      this.$router.back()
    },
    $open(url) {
      window.open(url)
    },
    $getOS() {
      const agent = navigator.userAgent.toLowerCase()
      const isMac = /macintosh|mac os x/i.test(navigator.userAgent)
      console.log('浏览器及系统：', agent)
      if (agent.indexOf("win") >= 0 || agent.indexOf("wow") >= 0) {
        return 'win'
      }
      if (isMac) {
        return 'mac'
      }
      return 'unknown'
    },
    $isSafari() {
      return /Safari/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent)
    },
    $setStore(key, value) {
      setStore({ name: key, content: value })
    },
    $getStore(key) {
      return getStore({ name: key })
    },
    $removeStore(key) {
      removeStore({ name: key })
    }
  }
}
